{
  "deselectedItem": "{item} לא נבחר.",
  "select": "בחר",
  "selectedAll": "כל הפריטים נבחרו.",
  "selectedCount": "{count, plural, =0 {לא נבחרו פריטים} one {פריט # נבחר} other {# פריטים נבחרו}}.",
  "selectedItem": "{item} נבחר."
}
